import { useNavigate } from "react-router-dom";

import { AccountItemLine } from "./AccountItem";
import { DSButton } from "../design-system/molecules";

export default function RevisionsSettings() {
  const navigate = useNavigate();
  return (
    <div
      id="revisionsSection"
      className="flex-1 flex flex-col gap-md"
    >
      <AccountItemLine dataTestId="revisions-line">
        <DSButton
          onClick={() => {
            navigate(`/audit_trail/user/`);
          }}
          dataTestId="view-revisions-button"
        >
          See All Patient / Note Revisions
        </DSButton>
      </AccountItemLine>
    </div>
  );
}
